"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var sanitized_render_1 = require("@reverbdotcom/commons/dist/components/sanitized_render");
var url_helpers_1 = require("../components/shared/url_helpers");
var scroll_target_1 = require("@reverbdotcom/commons/dist/components/scroll_target");
var humps_1 = require("humps");
exports.UPDATE_ADYEN_SHOP_OWNER_CONTEXT = 'update_adyen_shop_owner';
exports.UPDATE_ADYEN_COMPANY_DATA_CONTEXT = 'update_adyen_company_data';
exports.UPDATE_ADYEN_BANK_ACCOUNT_DATA_CONTEXT = 'update_adyen_bank_account_data';
exports.CONVERT_SHOP_TYPE_CONTEXT = 'convert_shop_type';
exports.NO_OP_ERROR_TYPE = 'no_op';
exports.ALREADY_CONVERTED_ERROR_TYPE = 'already_converted';
var renderValidationError = function (error, index) {
    var message = resolveErrorMessage(error);
    return (React.createElement("li", { className: "shop-onboarding-errors__item", key: index },
        React.createElement(sanitized_render_1.default, { html: message })));
};
var resolveErrorMessage = function (error) {
    if (error.context && error.error_type) {
        return contextualErrorMessage(error);
    }
    return error.message;
};
var contextualErrorMessage = function (error) {
    var context = error.context, error_type = error.error_type;
    if (context === exports.UPDATE_ADYEN_SHOP_OWNER_CONTEXT && error_type === exports.NO_OP_ERROR_TYPE) {
        return (I18n.t('discovery.coreOnboarding.validationErrors.shopOwnerUpdate.noOp', {
            tagOpen: "<a href=\"" + url_helpers_1.default.corePhotoIDVerificationPath + "\" target=\"_blank\">",
            tagClose: '</a>',
        }));
    }
    if (context === exports.UPDATE_ADYEN_COMPANY_DATA_CONTEXT && error_type === exports.NO_OP_ERROR_TYPE) {
        return (I18n.t('discovery.coreOnboarding.validationErrors.companyUpdate.noOp', {
            tagOpen: "<a href=\"" + url_helpers_1.default.contactUsPath + "\" target=\"_blank\">",
            tagClose: '</a>',
        }));
    }
    if (context === exports.UPDATE_ADYEN_BANK_ACCOUNT_DATA_CONTEXT && error_type === exports.NO_OP_ERROR_TYPE) {
        return (I18n.t('discovery.coreOnboarding.validationErrors.bankAccountUpdate.noOp'));
    }
    if (context === exports.CONVERT_SHOP_TYPE_CONTEXT && error_type === exports.ALREADY_CONVERTED_ERROR_TYPE) {
        return I18n.t('discovery.convertShopType.validationErrors.alreadyConverted');
    }
    return I18n.t('discovery.coreOnboarding.validationErrors.default');
};
var ValidationErrors = /** @class */ (function (_super) {
    tslib_1.__extends(ValidationErrors, _super);
    function ValidationErrors() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ValidationErrors.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.validationErrors.length > 0 &&
            prevProps.validationErrors.length === 0) {
            this.scrollToError();
        }
    };
    ValidationErrors.prototype.scrollToError = function () {
        if (this.refs.validationErrorsRef) {
            var typedScrollTarget = this.refs.validationErrorsRef;
            typedScrollTarget.scrollToTop();
        }
    };
    ValidationErrors.prototype.render = function () {
        var errors = this.props.validationErrors;
        if (!errors.length) {
            return null;
        }
        return (React.createElement("div", { className: "form-section" },
            React.createElement(scroll_target_1.default, { onlyScrollUp: true, ref: "validationErrorsRef" }),
            React.createElement("div", { className: "shop-onboarding-errors" },
                React.createElement("h2", { className: "shop-onboarding-errors__title" }, I18n.t('discovery.coreOnboarding.errors.title')),
                React.createElement("p", { className: "shop-onboarding-errors__subtitle" }, I18n.t('discovery.coreOnboarding.errors.subtitle')),
                React.createElement("ul", { className: "shop-onboarding-errors__items" }, errors.map(renderValidationError)))));
    };
    return ValidationErrors;
}(React.Component));
exports.default = ValidationErrors;
var RQLValidationErrors = /** @class */ (function (_super) {
    tslib_1.__extends(RQLValidationErrors, _super);
    function RQLValidationErrors() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RQLValidationErrors.prototype.render = function () {
        var rqlValidationErrors = this.props.validationErrors;
        var validationErrors = rqlValidationErrors.map(function (e) { return humps_1.decamelizeKeys(e); });
        return React.createElement(ValidationErrors, { validationErrors: validationErrors });
    };
    return RQLValidationErrors;
}(React.Component));
exports.RQLValidationErrors = RQLValidationErrors;
//# sourceMappingURL=validation_errors.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/onboarding/validation_errors.js
// module id = YcDN
// module chunks = 20 21